export var AfriexWalletType;
(function (AfriexWalletType) {
    AfriexWalletType["Deposit"] = "DEPOSIT";
    AfriexWalletType["Withdraw"] = "WITHDRAW";
    // Fee wallet: holds funds used solely to settle transaction fees for
    // businesses approved for fee-wallet settlement (isApprovedForFeeWallet).
    // Funded only via Admin credits; debited per-transaction when a fee applies
    // instead of baking the fee into the source/destination amount.
    AfriexWalletType["Fee"] = "FEE";
})(AfriexWalletType || (AfriexWalletType = {}));
//# sourceMappingURL=AfriexWalletType.js.map